export const MAX_PIVOTS = 3;
